import grundrissDeluxe from "@/assets/suites/grundriss-deluxe.webp";
import grundrissSwiss from "@/assets/suites/grundriss-swiss.webp";
import grundrissGarten from "@/assets/suites/grundriss-garten.webp";
import grundrissAustria from "@/assets/suites/grundriss-austria.webp";

import swissKitchen1 from "@/assets/suites/Swiss_Suite_Kueche_c_HWM_1.webp.asset.json";
import swissKitchen2 from "@/assets/suites/Swiss_Suite_Kueche_c_HWM_2.webp.asset.json";
import swissR1 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_1.webp.asset.json";
import swissR2 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_2.webp.asset.json";
import swissR3 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_3.webp.asset.json";
import swissR4 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_4.webp.asset.json";
import swissR5 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_5.webp.asset.json";
import swissR6 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_6.webp.asset.json";
import swissR7 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_7.webp.asset.json";
import swissR8 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_8.webp.asset.json";
import swissR9 from "@/assets/suites/Aparthotel_Lerch_Swiss_Suite_Rossner_Photgraphie_9.webp.asset.json";
import swissKitchenOverview from "@/assets/suites/Swiss_Suite_Kueche_HWM_overview.webp.asset.json";
import swissKitchenArlberg from "@/assets/suites/Swiss_Suite_Kueche_Arlberg.webp.asset.json";
import swissR4New from "@/assets/suites/Swiss_Suite_Rossner_4_new.webp.asset.json";
import swissR5New from "@/assets/suites/Swiss_Suite_Rossner_5_new.webp.asset.json";
import deluxeWohnraumArlberg2 from "@/assets/suites/Deluxe_Suite_Wohnraum_Arlberg_2.webp.asset.json";
import swissKuecheArlberg2 from "@/assets/suites/Swiss_Suite_Kueche_c_Arlberg_Fotografie_2.webp.asset.json";

import austriaKitchen1 from "@/assets/suites/Austria_Suite_Kueche_c_HWM_1.webp.asset.json";
import austriaKitchen2 from "@/assets/suites/Austria_Suite_Kueche_c_HWM_2.webp.asset.json";
import austriaR1 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_1.webp.asset.json";
import austriaR2 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_2.webp.asset.json";
import austriaR3 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_3.webp.asset.json";
import austriaR4 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_4.webp.asset.json";
import austriaR5 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_5.webp.asset.json";
import austriaR6 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_6.webp.asset.json";
import austriaR7 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_7.webp.asset.json";
import austriaR8 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_8.webp.asset.json";
import austriaR9 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_9.webp.asset.json";
import austriaR12 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_12.webp.asset.json";
import austriaR13 from "@/assets/suites/Aparthotel_Lerch_Austria_Suit_c_Rossner_Photographie_13.webp.asset.json";
import austriaR12New from "@/assets/suites/Austria_Suite_Rossner_12_new.webp.asset.json";
import austriaKuecheArlberg from "@/assets/suites/Austria_Suite_Kueche_c_Arlberg_Fotografie.webp.asset.json";

import deluxeKitchenHero from "@/assets/suites/Deluxe_Suite_Kueche_c_HWM_3.webp.asset.json";
import deluxeKitchenSlider from "@/assets/suites/Deluxe_Suite_Kueche_c_HWM_2.webp.asset.json";
import deluxeR1 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_1.webp.asset.json";
import deluxeR2 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_2.webp.asset.json";
import deluxeR3 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_3.webp.asset.json";
import deluxeR4 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_4.webp.asset.json";
import deluxeR5 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_5.webp.asset.json";
import deluxeR6 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_6.webp.asset.json";
import deluxeR7 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_7.webp.asset.json";
import deluxeR9 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_9.webp.asset.json";
import deluxeR12 from "@/assets/suites/Aparthotel_Lerch_Deluxe_Suite_c_Rossner_Photographie_12.webp.asset.json";
import deluxeKuecheArlberg from "@/assets/suites/Deluxe_Suite_Kueche_c_Arlberg_Fotografie.webp.asset.json";
import deluxeKuecheArlberg2 from "@/assets/suites/Deluxe_Suite_Kueche_c_Arlberg_Fotografie_2.webp.asset.json";

import gartenKitchen1 from "@/assets/suites/Garten_Suite_Kueche_c_HWM_1.webp.asset.json";
import gartenKitchen2 from "@/assets/suites/Garten_Suite_Kueche_c_HWM_2.webp.asset.json";
import gartenR1 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_1.webp.asset.json";
import gartenR2 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_2.webp.asset.json";
import gartenR3 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_3.webp.asset.json";
import gartenR4 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_4.webp.asset.json";
import gartenR5 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_5.webp.asset.json";
import gartenR6 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_6.webp.asset.json";
import gartenR7 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_7.webp.asset.json";
import gartenR8 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_8.webp.asset.json";
import gartenR9 from "@/assets/suites/Aparthotel_Lerch_Garten_Suite_c_Rossner_Photographie_9.webp.asset.json";
import gartenKitchenArlberg from "@/assets/suites/Garten_Suite_Kueche_Arlberg.webp.asset.json";
import gartenR8New from "@/assets/suites/Garten_Suite_Rossner_8_new.webp.asset.json";
import gartenR5New from "@/assets/suites/Garten_Suite_Rossner_5_new.webp.asset.json";
import gartenR1New from "@/assets/suites/Garten_Suite_Rossner_1_new.webp.asset.json";
import gartenKuecheArlberg from "@/assets/suites/Garten_Suite_Kueche_c_Arlberg_Fotografie.webp.asset.json";
import gartenKuecheArlberg1 from "@/assets/suites/Garten_Suite_Kueche_c_Arlberg_Fotografie_1.webp.asset.json";

/**
 * Post-Registry – WordPress-Beiträge (Suiten)
 * Kategorien-IDs (EasyBooking + WP):
 *   Garten 11 · Swiss 12 · Austria 13 · Deluxe 14
 */

export interface PostDefinition {
  slug: string;
  title: string;
  content: string;
  excerpt: string;
  categories: string[];
  featuredImage?: string;
  imageLandscape?: string;
  acfFields: Record<string, any>;
}

const swissGallery = [
  { image_url: swissKitchen1.url, alt: "Swiss Suite – Küche" },
  { image_url: swissR4.url, alt: "Swiss Suite – Schlafzimmer", object_position: "center top" },
  { image_url: swissKitchen2.url, alt: "Swiss Suite – Küche" },
  { image_url: swissR5.url, alt: "Swiss Suite – Wohnbereich" },
];

const swissImpressionen = [
  { image_url: swissKitchenArlberg.url, alt: "Swiss Suite – Impression" },
  { image_url: swissR4New.url, alt: "Swiss Suite – Impression" },
  { image_url: swissKuecheArlberg2.url, alt: "Swiss Suite – Wohn- und Essbereich mit Küche" },
  { image_url: swissR5New.url, alt: "Swiss Suite – Impression" },
  { image_url: swissR7.url, alt: "Swiss Suite – Impression" },
  { image_url: swissR8.url, alt: "Swiss Suite – Impression" },
];

const austriaGallery = [
  { image_url: austriaKuecheArlberg.url, alt: "Austria Suite – Wohn- und Essbereich mit Küche" },
  { image_url: austriaKitchen2.url, alt: "Austria Suite – Küche" },
  { image_url: austriaR13.url, alt: "Austria Suite – Schlafzimmer", object_position: "center top" },
  { image_url: austriaR9.url, alt: "Austria Suite – Wohnbereich" },
];

const austriaImpressionen = [
  { image_url: austriaR12New.url, alt: "Austria Suite – Impression" },
  { image_url: austriaR2.url, alt: "Austria Suite – Impression" },
  { image_url: austriaKuecheArlberg.url, alt: "Austria Suite – Wohn- und Essbereich mit Küche" },
  { image_url: austriaR6.url, alt: "Austria Suite – Impression" },
  { image_url: austriaR7.url, alt: "Austria Suite – Impression" },
  { image_url: austriaR8.url, alt: "Austria Suite – Impression" },
];

const deluxeGallery = [
  { image_url: deluxeWohnraumArlberg2.url, alt: "Deluxe Suite – Wohnraum mit Esstisch" },
  { image_url: deluxeR12.url, alt: "Deluxe Suite – Wohnbereich", object_position: "right center" },
  { image_url: deluxeKitchenSlider.url, alt: "Deluxe Suite – Küche" },
  { image_url: deluxeR9.url, alt: "Deluxe Suite – Schlafzimmer", object_position: "center top" },
  { image_url: deluxeR7.url, alt: "Deluxe Suite – Detail" },
];

const deluxeImpressionen = [
  { image_url: deluxeR6.url, alt: "Deluxe Suite – Impression" },
  { image_url: deluxeR1.url, alt: "Deluxe Suite – Impression" },
  { image_url: deluxeR2.url, alt: "Deluxe Suite – Impression" },
  { image_url: deluxeKuecheArlberg.url, alt: "Deluxe Suite – Wohnraum & Küche" },
  { image_url: deluxeR9.url, alt: "Deluxe Suite – Impression" },
  { image_url: deluxeKuecheArlberg2.url, alt: "Deluxe Suite – Wohn- und Essbereich" },
];

const gartenGallery = [
  { image_url: gartenKitchenArlberg.url, alt: "Garten Suite – Wohnküche" },
  { image_url: gartenKuecheArlberg1.url, alt: "Garten Suite – Wohnraum mit Küche" },
  { image_url: gartenR5New.url, alt: "Garten Suite – Schlafzimmer" },
  { image_url: gartenR1New.url, alt: "Garten Suite – Badezimmer" },
];

const gartenImpressionen = [
  { image_url: gartenR2.url, alt: "Garten Suite – Impression" },
  { image_url: gartenR3.url, alt: "Garten Suite – Impression" },
  { image_url: gartenR1New.url, alt: "Garten Suite – Badezimmer" },
  { image_url: gartenKuecheArlberg.url, alt: "Garten Suite – Wohnküche mit Sitzecke" },
  { image_url: gartenR9.url, alt: "Garten Suite – Impression" },
  { image_url: gartenKuecheArlberg1.url, alt: "Garten Suite – Wohnraum mit Küche" },
];

const emptySuiteAcf = {
  suite_subline: "",
  suite_groesse_qm: 0,
  suite_balkon_qm: 0,
  suite_personen_min: 0,
  suite_personen_max: 0,
  suite_schlafzimmer: 0,
  suite_baeder: 0,
  suite_eb_category_id: 0,
  suite_intro_text: "",
  suite_intro_image: "",
  suite_intro_image_alt: "",
  suite_overview_primary_image: "",
  suite_overview_primary_image_position: "",
  suite_overview_secondary_image: "",
  suite_overview_secondary_image_position: "",
  suite_gallery: [] as { image_url: string; alt?: string; caption?: string }[],
  suite_highlights_subline: "",
  suite_highlights_headline: "",
  suite_highlights_text: "",
  suite_features_headline: "",
  suite_features_text: "",
  suite_grundriss_image: "",
  suite_grundriss_pdf: "",
  suite_impressionen: [] as { image_url: string; alt?: string; caption?: string }[],
  suite_prices: [] as { season_name: string; period: string; price_from: string; note?: string }[],
};

export const postDefinitions: PostDefinition[] = [
  {
    slug: "deluxe-suite",
    title: "Deluxe Suite",
    content: "<p>Ihr Idyll des Wohlbefindens.</p>",
    excerpt: "Ihr Idyll des Wohlbefindens",
    categories: ["Suites"],
    acfFields: {
      ...emptySuiteAcf,
      suite_subline: "Extravaganz & Design auf\u00A095\u00A0m²",
      suite_groesse_qm: 95,
      suite_balkon_qm: 27,
      suite_personen_min: 6,
      suite_personen_max: 8,
      suite_schlafzimmer: 3,
      suite_baeder: 3,
      suite_eb_category_id: 14,
      suite_intro_text:
        "Die Deluxe Suite bietet auf 95 m² Wohnfläche sowie 27 m² Balkon oder Terrasse großzügigen Platz für Ihren Urlaub. Drei Doppelzimmer mit jeweils eigenem Bad mit Regendusche und WC sorgen für Privatsphäre und Komfort. Der offene Wohnbereich mit voll ausgestatteter Küche, gemütlicher Sitzecke und zusätzlicher Schlafcouch mit hochwertiger Matratze bieten Raum für gemeinsame Zeit und entspannte Stunden. Ideal für 6 bis 8 Personen.",
      suite_intro_image: deluxeKitchenHero.url,
      suite_intro_image_alt: "Deluxe Suite – Küche",
      suite_overview_primary_image: deluxeR12.url,
      suite_overview_primary_image_position: "80% center",
      suite_overview_secondary_image: deluxeKitchenSlider.url,
      suite_overview_secondary_image_position: "center",
      suite_gallery: deluxeGallery,
      suite_highlights_subline: "Viel Platz und hochwertige Ausstattung",
      suite_highlights_headline: "Highlights der Deluxe Suite",
      suite_highlights_text:
        "Drei Doppelzimmer, ein offener Wohnbereich mit voll ausgestatteter Küche sowie zwei zusätzliche Schlafmöglichkeiten im Wohnbereich bieten viel Platz für Ihren Aufenthalt. Flat-TVs in allen Räumen und der Zugang zur Terrasse mit schöner Aussicht sorgen für zusätzlichen Komfort.",
      suite_features_headline: "Ausstattung und Komfort",
      suite_features_text: `3 Doppelzimmer
1 Schlafcouch für 2 Personen im Wohnraum
Bad mit Regendusche und WC zu jedem Zimmer, Handtücher, Föhn
Offener Wohnraum mit voll ausgestatteter Küche: Geschirrspüler, Herd, Backofen, Mikrowelle, Kaffeemaschine, Wasserkocher
Unterhaltung: Flat-TVs in allen Schlafzimmern, WLAN
Terrasse mit Ausblick`,
      suite_grundriss_image: grundrissDeluxe,
      suite_impressionen: deluxeImpressionen,
    },
  },
  {
    slug: "swiss-suite",
    title: "Swiss Suite",
    content: "<p>Wo Genuss zur Einrichtung gehört.</p>",
    excerpt: "Wo Genuss zur Einrichtung gehört",
    categories: ["Suites"],
    acfFields: {
      ...emptySuiteAcf,
      suite_subline: "Unvergleichliches Wohlfühlerlebnis auf\u00A070\u00A0m²",
      suite_groesse_qm: 70,
      suite_balkon_qm: 30,
      suite_personen_min: 4,
      suite_personen_max: 7,
      suite_schlafzimmer: 2,
      suite_baeder: 2,
      suite_eb_category_id: 12,
      suite_intro_text:
        "Die Swiss Suite bietet auf 70 m² Wohnfläche sowie einem 30 m² großen Balkon viel Platz für einen entspannten Aufenthalt in Kappl. Ein Doppelzimmer, ein Dreibettzimmer und ein offener Wohnbereich mit voll ausgestatteter Küche schaffen eine angenehme, offene Atmosphäre. Eine zusätzliche Schlafmöglichkeit im Wohnbereich ergänzt das Raumangebot. Jedes Zimmer verfügt über ein eigenes Bad mit Regendusche und WC. Ideal für 4 bis 7 Personen.",
      suite_intro_image: swissKitchen1.url,
      suite_intro_image_alt: "Swiss Suite – Küche",
      suite_overview_primary_image: swissR9.url,
      suite_overview_primary_image_position: "70% bottom",
      suite_overview_secondary_image: swissKitchenOverview.url,
      suite_overview_secondary_image_position: "left center",
      suite_gallery: swissGallery,
      suite_highlights_subline: "Durchdacht ausgestattet mit viel Raum",
      suite_highlights_headline: "Highlights der Swiss Suite",
      suite_highlights_text:
        "Ein Doppelzimmer und ein Dreibettzimmer sowie ein offener Wohnbereich mit voll ausgestatteter Küche bieten angenehmen Wohnkomfort. Zwei zusätzliche Schlafmöglichkeiten im Wohnbereich, Flat-TVs in allen Räumen und der Zugang zum Balkon mit schöner Aussicht aus allen Zimmern runden das Angebot ab.",
      suite_features_headline: "Ausstattung und Komfort",
      suite_features_text: `1 Doppelzimmer
1 Dreibettzimmer
1 Schlafcouch für 2 Personen im Wohnraum
Bad mit Regendusche und WC zu jedem Zimmer, Handtücher, Föhn
Offener Wohnraum mit voll ausgestatteter Küche: Geschirrspüler, Herd, Backofen, Mikrowelle, Kaffeemaschine, Wasserkocher
Unterhaltung: Flat-TVs in allen Schlafzimmern, WLAN
Von allen Räumen Zugang zum Balkon mit imposantem Ausblick`,
      suite_grundriss_image: grundrissSwiss,
      suite_impressionen: swissImpressionen,
    },
  },
  {
    slug: "garten-suite",
    title: "Garten Suite",
    content: "<p>Wo Stunden im Garten Entspannung versprechen.</p>",
    excerpt: "Wo Stunden im Garten Entspannung versprechen",
    categories: ["Suites"],
    acfFields: {
      ...emptySuiteAcf,
      suite_subline: "Ihr privates Gartenparadies auf\u00A070\u00A0m²",
      suite_groesse_qm: 70,
      suite_balkon_qm: 30,
      suite_personen_min: 4,
      suite_personen_max: 7,
      suite_schlafzimmer: 2,
      suite_baeder: 2,
      suite_eb_category_id: 11,
      suite_intro_text:
        "Die Garten Suite bietet auf 70 m² Wohnfläche sowie einer 30 m² großen Terrasse mit eigenem Garten ein besonderes Urlaubsgefühl für Ihren Aufenthalt bei uns in Kappl. Helle Räume, eine hochwertige Ausstattung und durchdachte Details schaffen eine angenehme Atmosphäre. Ein Doppelzimmer, ein Dreibettzimmer und eine zusätzliche Schlafcouch mit hochwertiger Matratze im Wohnbereich bieten Platz für 4 bis 7 Personen. Alle Schlafzimmer verfügen über ein eigenes Bad mit Regendusche und WC.",
      suite_intro_image: gartenKitchen2.url,
      suite_intro_image_alt: "Garten Suite – Küche",
      suite_overview_primary_image: gartenR9.url,
      suite_overview_secondary_image: gartenKitchen2.url,
      suite_gallery: gartenGallery,
      suite_highlights_subline: "Viel Raum mit eigener Terrasse und Garten",
      suite_highlights_headline: "Highlights der Garten Suite",
      suite_highlights_text:
        "Ein Doppelzimmer und ein Dreibettzimmer sowie ein offener Wohnbereich mit voll ausgestatteter Küche bieten angenehmen Wohnkomfort. Zwei zusätzliche Schlafmöglichkeiten im Wohnbereich schaffen weiteren Platz und der eigene Garten mit Terrasse lädt zum Entspannen ein.",
      suite_features_headline: "Ausstattung und Komfort",
      suite_features_text: `1 Doppelzimmer
1 Dreibettzimmer
1 Schlafcouch für 2 Personen im Wohnraum
Bad mit Regendusche und WC zu jedem Zimmer, Handtücher, Föhn
Offener Wohnraum mit voll ausgestatteter Küche: Geschirrspüler, Herd, Backofen, Mikrowelle, Kaffeemaschine, Wasserkocher
Unterhaltung: Flat-TVs in allen Schlafzimmern, WLAN
Eigener Garten mit wunderschöner Terrasse, Zugang von allen Zimmern`,
      suite_grundriss_image: grundrissGarten,
      suite_impressionen: gartenImpressionen,
    },
  },
  {
    slug: "austria-suite",
    title: "Austria Suite",
    content: "<p>Freiheit für entspannte Urlaubstage.</p>",
    excerpt: "Freiheit für entspannte Urlaubstage",
    categories: ["Suites"],
    acfFields: {
      ...emptySuiteAcf,
      suite_subline: "Freiraum & Entspannung auf\u00A090\u00A0m²",
      suite_groesse_qm: 90,
      suite_balkon_qm: 30,
      suite_personen_min: 6,
      suite_personen_max: 9,
      suite_schlafzimmer: 3,
      suite_baeder: 3,
      suite_eb_category_id: 13,
      suite_intro_text:
        "Die Austria Suite bietet auf 90 m² Wohnfläche sowie einem 30 m² großen Balkon viel Raum für Ihren Aufenthalt. Zwei Doppelzimmer und ein Dreibettzimmer sorgen für eine angenehme Aufteilung, ergänzt durch einen offenen Wohnbereich mit voll ausgestatteter Küche. Eine zusätzliche Schlafcouch mit hochwertiger Matratze im Wohnbereich erweitert das Platzangebot. Alle Zimmer verfügen über ein eigenes Bad mit Regendusche und WC. Ideal für 6 bis 9 Personen.",
      suite_intro_image: austriaKitchen1.url,
      suite_intro_image_alt: "Austria Suite – Küche",
      suite_overview_secondary_image: austriaR12.url,
      suite_gallery: austriaGallery,
      suite_highlights_subline: "Ideale Raumaufteilung und moderne Einrichtung",
      suite_highlights_headline: "Highlights der Austria Suite",
      suite_highlights_text:
        "Zwei Doppelzimmer und ein Dreibettzimmer sowie ein offener Wohnbereich mit voll ausgestatteter Küche bieten viel Raum für Ihren Aufenthalt in diesem Apartment. Zwei zusätzliche Schlafmöglichkeiten im Wohnbereich schaffen weiteren Platz. Der Zugang zum Balkon mit schöner Aussicht aus allen Zimmern sorgt für ein rundum angenehmes Wohngefühl.",
      suite_features_headline: "Ausstattung und Komfort",
      suite_features_text: `2 Doppelzimmer
1 Dreibettzimmer
1 Schlafcouch für 2 Personen im Wohnraum
Bad mit Regendusche und WC zu jedem Zimmer, Handtücher, Föhn
Offener Wohnraum mit voll ausgestatteter Küche: Geschirrspüler, Herd, Backofen, Mikrowelle, Kaffeemaschine, Wasserkocher
Unterhaltung: Flat-TVs in allen Schlafzimmern, WLAN
Von allen Räumen Zugang zum Balkon mit beeindruckendem Ausblick`,
      suite_grundriss_image: grundrissAustria,
      suite_impressionen: austriaImpressionen,
    },
  },
];
